module.exports = __webpack_public_path__ + "img/jiax3.41faf0de.png";